/**
 * src/lib/agent/pendingAgentOpen.js — TICKET-1499.
 *
 * `open-agent-chat` (e.g. a project's Chats tab "New Chat" with { projectId }) makes
 * AppShell switch to the Agent tab, whose AgentShell mounts AFTER the event fired, so
 * the scope was lost and the conversation was stored with scope [] and null ids.
 * AgentShellTrigger (mounted when the event fires) stashes the detail here; the Agent
 * tab takes it once on mount. A stale stash (>5 s) is ignored.
 */
const MAX_AGE_MS = 5000;
let pending = null;

export function stashAgentOpen(detail, now = Date.now()) {
  pending = detail ? { detail, at: now } : null;
}

export function takeAgentOpen(now = Date.now()) {
  const p = pending;
  pending = null;
  return p && now - p.at <= MAX_AGE_MS ? p.detail : null;
}
